import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import type { ContractLexicalContent } from '@/features/contract/index.ts'
import { RentalBatchContractPrintPreview, rentalBatchContractSearchSchema } from '@/features/order/index.ts'

export const Route = createFileRoute('/_authenticated/orders/contracts/print')({
  validateSearch: rentalBatchContractSearchSchema.extend({
    orderType: z.enum(['rental', 'service']),
    documentIds: z.array(z.number().int().positive().safe()).min(1).max(400)
  }),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    const groups = await Promise.all(
      deps.ids.map((orderId) =>
        context.queryClient.fetchQuery({
          ...context.trpc.order.contracts.documents.queryOptions({ orderType: deps.orderType, orderId }),
          staleTime: 0
        })
      )
    )
    const documents = new Map(groups.flat().map((document) => [document.id, document]))
    return deps.documentIds.map((id) => {
      const document = documents.get(id)
      if (!document) throw new Error('待打印合同不存在或不属于所选订单，请回到原标签页重新打开打印预览')
      return { id, title: document.title, content: document.content as ContractLexicalContent }
    })
  },
  component: PrintPage,
  head: () => ({ meta: [{ title: '合同打印预览 · Super Mega' }] })
})

function PrintPage() {
  const documents = Route.useLoaderData()
  return <RentalBatchContractPrintPreview documents={documents} />
}
